"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlertTypeColors = void 0;
var styled_components_1 = require("styled-components");
var useAlertTypeColors = function (type) {
    if (type === void 0) { type = 'info'; }
    var theme = (0, styled_components_1.useTheme)();
    var _a = theme.colors.bg, success = _a.success, lightSuccess = _a.lightSuccess, warning = _a.warning, lightWarning = _a.lightWarning, info = _a.info, lightInfo = _a.lightInfo, error = _a.error, lightError = _a.lightError;
    var _b = theme.colors.text, darkError = _b.darkError, darkInfo = _b.darkInfo, darkSuccess = _b.darkSuccess, darkWarning = _b.darkWarning;
    switch (type) {
        case 'success':
            return [success, lightSuccess, darkSuccess];
        case 'warning':
            return [warning, lightWarning, darkWarning];
        case 'info':
            return [info, lightInfo, darkInfo];
        case 'error':
        default:
            return [error, lightError, darkError];
    }
};
exports.useAlertTypeColors = useAlertTypeColors;
